import { billingTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const BillingTypeAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "330px" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.billingType ?? ""}
                        fieldValue={chargeBatchUpdate.billingType}
                        fieldLabel={"Billing Type"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'billingType'}
                        maxLength={60}
                        options={billingTypeDropdownOption}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
        </>
    )
}